/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { rootUrl } from "../actions/constants";

export const initialState = {
  rosterOwnerList: [],
  protocolList: [],
  credTypeList: [],
  browserLeadOrgList: []
};

export const rosterOwnerLovSelector = state => state.listOfValues?.rosterOwnerList;
export const protocolLovSelector = state => state.listOfValues.protocolList;
export const credTypeLovSelector = state => state.listOfValues.credTypeList;
export const browserLeadOrgLovSelector = state => state.listOfValues.browserLeadOrgList;
export const institutionGridExportTitleSelector = state =>
  `(${state?.institutionAffiliation?.data?.ctepId} - ${state?.institutionAffiliation?.data?.name})`;

export function rosterOwnerListSelector(state) {
  const { rosterOwnerList = [] } = state.listOfValues;
  return rosterOwnerList.map(l => l.value);
}

export const ListOfValueSlice = createSlice({
  name: "ListOfValue",
  initialState,
  reducers: {
    setRosterOwnerLovList: (state, action) => {
      state.rosterOwnerList = action.payload;
    },
    setProtocolList: (state, action) => {
      state.protocolList = action.payload;
    },
    setCredTypeList: (state, action) => {
      state.credTypeList = action.payload;
    },
    setNonNumericIdList: (state, action) => {
      state.data = action.payload;
    },
    setBrowserLeadOrgList: (state, action) => {
      state.browserLeadOrgList = action.payload;
    }
  }
});

export const {
  setRosterOwnerLovList,
  setProtocolList,
  setCredTypeList,
  setBrowserLeadOrgList
} = ListOfValueSlice.actions;

export const fetchRosterOwnerLov = () => async dispatch => {
  const response = await makeAjaxRequest.fetchWithAuth(`${rootUrl}/lov/rosterowner`);
  dispatch(setRosterOwnerLovList(response));
};
export const fetchProtocolLov = () => async dispatch => {
  const response = await makeAjaxRequest.fetchWithAuth(`${rootUrl}/lov/institprovidercredprotocol`);
  dispatch(setProtocolList(response));
};
export const fetchCredTypeLov = () => async dispatch => {
  const response = await makeAjaxRequest.fetchWithAuth(`${rootUrl}/lov/institprovidercredtype`);
  dispatch(setCredTypeList(response));
};
export const fetchBrowserLeadOrgLov = () => async dispatch => {
  const response = await makeAjaxRequest.fetchWithAuth(`${rootUrl}/lov/institsiterestrictbrowserleadorg`);
  dispatch(setBrowserLeadOrgList(response));
};

export default ListOfValueSlice.reducer;
